module.exports = __webpack_public_path__ + "static-portal/img/2.d709cff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.jpg
// module id = Mn6R
// module chunks = 4